import { render } from "./HomeComponent.vue?vue&type=template&id=17c63815"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"

import "./HomeComponent.vue?vue&type=style&index=0&id=17c63815&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__